export const separateInstrumentAndStrike = (instrumentWithStrike: string) => {
  // Regular expression pattern to match the instrument and strike
  const pattern = /^(.*?)\s+(.*)$/;

  // Extract the instrument and strike using regular expression match
  const [, instrument, strike] = instrumentWithStrike.match(pattern) || [];

  return { instrument, strike };
};
